// extracted by mini-css-extract-plugin
export default {"div-item":"ScrollViewer_div-item__1UH+6"};